
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'
import './assets/css/style.css'


import { Routes, Route ,Link} from 'react-router-dom';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import Register from './pages/Auth/Register';
import StudentLayout from './layouts/student'
import ResetPassowrdPage from './pages/Auth/ResetPassword';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Login/>}/>
        <Route exact path='/login' element={<Login/>}/>
        <Route exact path='/forgot-password' element={<ForgotPassword/>}/>
        <Route exact path='/reset-password/:resetCode' element={<ResetPassowrdPage/>}/>
        <Route exact path='/register' element={<Register/>}/>
        <Route exact path='student/*' element={<StudentLayout/>}/>
        <Route path='*' element={
          <div className='page_not_found'>
          <h1 className='text-center'>404</h1>
          <p>Page not found</p>
          <Link to={'login'} className='btn btn-primary'>Back to Home</Link>
          </div>
        }/>
      </Routes>
    </div>
  );
}

export default App;
